<template>
  <v-row class="mx-auto">
    <v-col class="pb-0" cols="12">
      <v-data-table
        id="expurgo-datas-versoes"
        v-model="selectedItemLocal"
        :headers="headers"
        :items="items"
        item-key="key"
        :single-select="true"
        show-select
        :loading="loading"
        :hide-default-header="loading"
        :sort-by="['DataRegistro', 'versao']"
        class="elevation-1"
        hide-default-footer
        disable-pagination
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.DataRegistro`]="{ item }">
          {{ item.DataRegistro | formatToMonth }}
        </template>
        <template v-slot:[`item.numeroRegistros`]="{ item }">
          {{ item.numeroRegistros | parseNumberToIntegerBR }}
        </template>
      </v-data-table>

    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    itemsTable: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [],
    headers: [
      { 
        text: 'Mês',
        align: 'center',
        value: 'DataRegistro'
      },
      {
        text: 'Versão',
        align: 'center',
        value: 'versao'
      },
      {
        text: 'Nº de Linhas',
        align: 'center',
        value: 'numeroRegistros'
      }
    ]
  }),

  computed: {
    selectedItemLocal: {
      get() {
        return this.selectedItem;
      },
      set(newValue) {
        this.$emit('update:selectedItem', newValue);
      }
    }
  },

  watch: {
    itemsTable() {
      this.items = this.itemsTable.map(item => {
        item.key = item.DataRegistro + '-' + item.versao;
        return item;
      });
    },
    selectedItem(arrNewVal) {
      this.$emit('stepReleased', arrNewVal.length);
    }
  },

}
</script>